import { Map } from "immutable"
import * as React from "react"
import { IOWidget, Updater, fromJSX, unloadedAsyncState } from "widgets-for-react"
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState, Id, ImageSize, Url } from "../../../../cms/blocks/types.gen"


export type personBlockProps = {
  block_index: number,
  name: string
  role: string
  email?: string
  phone?: string
  image?: Id
  image_alt?: string
}

export type personBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
}>

export function personBlock(
  props: personBlockProps,
  options?: { style: personBlockStyle; key?: string }
): (s:CMSState) => IOWidget<PublicSiteState, Updater<CMSState>> {
    return (s: CMSState) => (public_state:PublicSiteState) =>
    fromJSX(() => {
        const imageRes = s.images.get(props.image, unloadedAsyncState())
        const image: Map<ImageSize, Url> = imageRes && imageRes.kind == 'loaded' ? imageRes.value : Map()
        return (
          <section className={options && options.style ? options.style.block_classname : ""} key={options.key}>
            <div className={options && options.style ? options.style.inner_classname : ""}>
              <header className={options && options.style ? options.style.header_classname : ""}>
                <h2 className={options && options.style ? options.style.title_classname : ""}>Lorem ipsum dolor sit amet</h2>
              </header>

              <div className={options && options.style ? options.style.content_classname : ""}>
                <aside className="person person--default">
                  <div className="person__inner">
                    <header className="person__header">
                      <span className="person__function tag--m">{props.role}</span>
                      <h3 className="person__name title--s">{props.name}</h3>
                    </header>

                    {(props.email || props.phone) && (
                      <div className="person__content">
                        <ul className="person__contact">
                          {props.email && (
                            <li className="ellipsis">
                              <a className="text--s link--default" href={`mailto:${props.email}`}>{props.email}</a>
                            </li>
                          )}

                          {props.phone && (
                            <li>
                              <a className="text--s link--default" href={`tel:${props.phone}`}>{props.phone}</a>
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                  </div>

                  <div className="person__visual">
                    {imageRes.kind == 'loaded' && (
                      <img
                        loading="lazy"
                        className="person__image" height="208" width="208" alt=""
                        src={image.get('medium')}
                      />
                    )}
                  </div>
                </aside>
              </div>
            </div>
          </section>
        )
      },
    )
}
